import { Collapse, Stack, Button, styled, useTheme } from '@mui/material';
import { ReactNode, useMemo, useState } from 'react';
import { RiArrowDropDownFill, RiArrowDropUpFill } from 'react-icons/ri';
import { BUTTON_HOVER_SHADOWS } from 'src/theme/shadows';
import { useRouter } from 'next/router';
import { subNavbarConfig } from 'src/layouts/dashboard/navbar/config';

type Props = {
  title: string;
  icon: ReactNode;
  children: ReactNode;
};
export const NavCollapseButton = ({ title, icon, children }: Props) => {
  const router = useRouter();
  const isTarget: boolean = useMemo(
    () => subNavbarConfig.some((config) => config.href === router.pathname),
    [router.pathname]
  );
  const [isOpen, setIsOpen] = useState<boolean>(isTarget);
  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };
  const theme = useTheme();
  return (
    <Stack
      padding="4px"
      gap="4px"
      sx={{
        backgroundColor: isOpen ? theme.palette.grey[250] : theme.palette.grey[100],
        borderRadius: '4px',
      }}
    >
      <StyledButton
        startIcon={icon}
        endIcon={isOpen ? <RiArrowDropUpFill /> : <RiArrowDropDownFill />}
        onClick={handleClick}
      >
        {title}
      </StyledButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Stack>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[100],
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  padding: '5px 0',
  '& .MuiButton-startIcon': {
    marginLeft: '12px',
    marginRight: '12px',
  },
  ':hover': {
    filter: BUTTON_HOVER_SHADOWS,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    // hover時のアイコンの色をメインカラーに変更
    '& .MuiButton-startIcon': {
      color: theme.palette.primary.main,
    },
  },
  // focus時に太字にする
  ':focus': {
    fontWeight: 'bold',
  },
}));
